import { render, staticRenderFns } from "./DatosAbonoCard.vue?vue&type=template&id=143e8fb3"
import script from "./DatosAbonoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DatosAbonoCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports